import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useWindowSize } from '@/hooks/useWindowSize';
import s from './index.module.scss';

const id = MODAL_IDS.review_participation;

export const ReviewParticipationModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

export const Modal = () => {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();
  const { closeModal } = useModal();

  const content = (
    <div className={s.modal}>
      <h1 className="f-h2 f-500">
        {t('modal:review_participation_modal.claim_assignment_vs_crowdfunding')}
      </h1>
      <div className={s.content}>
        <div>{t('modal:review_participation_modal.investor_role_description')}</div>
        <div className="f-body-md f-500">{t('modal:review_participation_modal.what_is_a_claim_to_a_loan')}</div>
        <div> {t('modal:review_participation_modal.claim_definition')} </div>
        <div>
          {t('modal:review_participation_modal.lender_makes_loan_description')}
        </div>
        <div>
          {t('modal:review_participation_modal.rights_available_for_assignment')}
        </div>
        <div>
          {t('modal:review_participation_modal.assignment_agreement_description')}
        </div>
        <div>
          {t('modal:review_participation_modal.acquirers_rights_and_limitations')}
        </div>
        <div>
          {t('modal:review_participation_modal.scramble_services_and_distribution')}
        </div>
        <div>{t('modal:review_participation_modal.risk_disclaimer')}</div>
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
